import React from 'react';
import useStyles from './styles';

function SignUpEmailSent() {
  const c = useStyles();

  return (
    <div className={c.container}>
      <h1>Email Sent</h1>
      <h4>Check your email to activate your account</h4>
      <a href="/">Click here to login</a>
    </div>
  );
}

export default SignUpEmailSent;